import { render, staticRenderFns } from "./AddSftpUserModal.vue?vue&type=template&id=778bd941&scoped=true&"
import script from "./AddSftpUserModal.vue?vue&type=script&lang=ts&"
export * from "./AddSftpUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bd941",
  null
  
)

export default component.exports